/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExternalDeviceType,
    ExternalDeviceTypeFromJSON,
    ExternalDeviceTypeFromJSONTyped,
    ExternalDeviceTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface MuDataProcessingModelsActivityIntervalExternalDevice
 */
export interface MuDataProcessingModelsActivityIntervalExternalDevice {
    /**
     * 
     * @type {string}
     * @memberof MuDataProcessingModelsActivityIntervalExternalDevice
     */
    serialNumber: string;
    /**
     * 
     * @type {ExternalDeviceType}
     * @memberof MuDataProcessingModelsActivityIntervalExternalDevice
     */
    deviceType: ExternalDeviceType;
    /**
     * 
     * @type {string}
     * @memberof MuDataProcessingModelsActivityIntervalExternalDevice
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof MuDataProcessingModelsActivityIntervalExternalDevice
     */
    source: string;
    /**
     * 
     * @type {Date}
     * @memberof MuDataProcessingModelsActivityIntervalExternalDevice
     */
    tfrom: Date;
    /**
     * 
     * @type {object}
     * @memberof MuDataProcessingModelsActivityIntervalExternalDevice
     */
    metadata: object;
    /**
     * 
     * @type {object}
     * @memberof MuDataProcessingModelsActivityIntervalExternalDevice
     */
    data?: object;
}

export function MuDataProcessingModelsActivityIntervalExternalDeviceFromJSON(json: any): MuDataProcessingModelsActivityIntervalExternalDevice {
    return MuDataProcessingModelsActivityIntervalExternalDeviceFromJSONTyped(json, false);
}

export function MuDataProcessingModelsActivityIntervalExternalDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MuDataProcessingModelsActivityIntervalExternalDevice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serialNumber': json['serial_number'],
        'deviceType': ExternalDeviceTypeFromJSON(json['device_type']),
        'deviceId': !exists(json, 'device_id') ? undefined : json['device_id'],
        'source': json['source'],
        'tfrom': (new Date(json['tfrom'])),
        'metadata': json['metadata'],
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function MuDataProcessingModelsActivityIntervalExternalDeviceToJSON(value?: MuDataProcessingModelsActivityIntervalExternalDevice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'serial_number': value.serialNumber,
        'device_type': ExternalDeviceTypeToJSON(value.deviceType),
        'device_id': value.deviceId,
        'source': value.source,
        'tfrom': (value.tfrom.toISOString()),
        'metadata': value.metadata,
        'data': value.data,
    };
}


